import { Link } from 'react-router-dom';
import type { ContentItem } from '@/lib/content';
import ContentCard from '@/components/feature/ContentCard';
import SectionHeading from '@/components/feature/SectionHeading';

export default function CastSpotlight({ items }: { items: ContentItem[] }) {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
      <SectionHeading
        eyebrow="CAST"
        title="演员阵容：三个人，三种沉默"
        description="从主演到只有六场戏的长辈角色，每位演员都为人物写了不拍出来的前史。点开卡片可以读到他们的角色理解。"
        moreTo="/cast"
        moreLabel="查看全部演员"
      />
      <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
        {items.map((item, index) => (
          <ContentCard key={item.id} item={item} variant="person" index={index} />
        ))}
      </div>
      <div className="mt-8 flex flex-wrap items-center gap-3">
        {['主演', '配角', '回忆线', '长辈角色'].map((tag) => (
          <Link
            key={tag}
            to="/cast"
            className="rounded-full border border-background-300/70 px-3 py-1.5 text-xs text-foreground-400 transition-colors hover:border-primary-500/50 hover:text-primary-300"
          >
            {tag}
          </Link>
        ))}
        <span className="text-xs text-foreground-600">按姓名索引可在演员页使用</span>
      </div>
    </section>
  );
}